import { lazy } from 'react';

export const AllRoutes = [
    // {
    //     path: '/auth/signin',
    //     Component: lazy(() => import('src/pages/auth/signin')),
    //     is_authroute: false,
    //     name: 'SignInPages',
    // },
    {
        path: '/',
        Component: lazy(() => import('src/pages/Home')),
        is_authroute: false,
        name: 'HomePage',
    },
    {
        path: '/snippet/questionanswer',
        Component: lazy(() => import('src/pages/snippet/questionanswer')),
        is_authroute: false,
        name: 'QuestionAnswer',
    },
    {
        path: '/snippet/trainingDataView',
        Component: lazy(() => import('src/pages/snippet/trainingdata')),
        is_authroute: false,
        name: 'TrainingDataView',
    },
    {
        path: '/snippet/trainingDataView_2',
        Component: lazy(() => import('src/pages/snippet/trainingdata_2')),
        is_authroute: false,
        name: 'TrainingDataView_2',
    },
    {
        path: '/snippet/parser',
        Component: lazy(() => import('src/pages/snippet/Parser')),
        is_authroute: false,
        name: 'Parser',
    },
    {
        path: '/snippet/parser2',
        Component: lazy(() => import('src/pages/snippet/Parse2')),
        is_authroute: false,
        name: 'Parse2',
    },
    {
        path: '/snippet/regression',
        Component: lazy(() => import('src/pages/snippet/regression')),
        is_authroute: false,
        name: 'Regression',
    },
    {
        path: '/snippet/parser/pdf',
        Component: lazy(() => import('src/pages/snippet/PdfViewer')),
        is_authroute: false,
        name: 'PdfViewer',
    }
]